import { AvatarConfig, AvatarModule, AvatarSource } from 'ngx-avatars';

import { CommonModule } from '@angular/common';
import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';

import { MATERIAL_COLOR_ARRAY } from '@lib/common/constants';

import { SnAvatarComponent } from './components/avatar/avatar.component';

@NgModule({
  imports: [CommonModule, AvatarModule],
  exports: [SnAvatarComponent],
  declarations: [SnAvatarComponent],
})
export class SnAvatarModule {
  public static forRoot(): ModuleWithProviders<SnAvatarModule> {
    const AVATAR_CONFIG = new InjectionToken<AvatarConfig>('AVATAR_CONFIG');

    return {
      ngModule: SnAvatarModule,
      providers: [
        {
          provide: AVATAR_CONFIG,
          useValue: {
            colors: MATERIAL_COLOR_ARRAY,
            sourcePriorityOrder: [AvatarSource.CUSTOM, AvatarSource.INITIALS],
          },
        },
      ],
    };
  }
}
